import ReactPixel from 'react-facebook-pixel';

const options = {
  autoConfig: true,
  debug: false, 
};

const initFacebookPixel = (pixelId) => {
  ReactPixel.init(pixelId, {}, options);
  ReactPixel.pageView(); 
};

export { initFacebookPixel, ReactPixel };

